/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Container, Row, Col } from "react-awesome-styled-grid";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Box, Navigation } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";
import { StyledLink } from "~/components/Styled/Common";
import { navItems } from "~/constants/navItems";
import { ROUTES } from "~/routing";
import { Logo } from "./Logo";
import { User } from "./User";

const LogoWrap = styled.div`
  flex: 1;
`;

const NavItem = styled(Navigation.Item)`
  margin-left: 0.4rem;
`;

export default function Navbar() {
  return (
    <Box spacing="spacing04" padding="1.25rem 0">
      <Container>
        <Row justify="space-between">
          <LogoWrap>
            <Col>
              <FlexContainer height="2.5rem">
                <Link css={{ marginRight: "1rem" }} to={ROUTES.customers.index}>
                  <Logo />
                </Link>
                <Navigation.Container>
                  <NavItem as="div">
                    <StyledLink
                      to={ROUTES.customers.index}
                      data-cy="nav-customers"
                    >
                      {navItems.customers}
                    </StyledLink>
                  </NavItem>

                  <NavItem as="div">
                    <StyledLink
                      to={ROUTES.employees.index}
                      data-cy="nav-employees"
                    >
                      {navItems.employees}
                    </StyledLink>
                  </NavItem>

                  {/* Disabled in UI only
                  https://nordcloud.atlassian.net/browse/EX-208
                  */}
                  {/* <NavItem as="div" data-cy="nav-services">
                    <StyledLink to={ROUTES.services.offerings}>
                      {navItems.services}
                    </StyledLink>
                  </NavItem> */}

                  <NavItem as="div" data-cy="nav-service-commitments">
                    <StyledLink to={ROUTES.serviceCommitments.index}>
                      {navItems.serviceCommitments}
                    </StyledLink>
                  </NavItem>

                  <NavItem as="div" data-cy="nav-product-catalog">
                    <StyledLink to={ROUTES.productCatalog.index}>
                      {navItems.productCatalog}
                    </StyledLink>
                  </NavItem>

                  <NavItem as="div" data-cy="nav-tool">
                    <StyledLink to={ROUTES.tool.index}>
                      {navItems.tool}
                    </StyledLink>
                  </NavItem>

                  <NavItem as="div" data-cy="nav-report">
                    <StyledLink to={ROUTES.reporting.index}>
                      {navItems.reporting}
                    </StyledLink>
                  </NavItem>
                </Navigation.Container>
              </FlexContainer>
            </Col>
          </LogoWrap>
          <FlexContainer height="2.5rem">
            <Col align="flex-end">
              <User />
            </Col>
          </FlexContainer>
        </Row>
      </Container>
    </Box>
  );
}
